import { useState } from "react";

const Notificaciones = () => {
  const [notificaciones, setNotificaciones] = useState([
    {
      id: 1,
      tipo: "info",
      titulo: "Actualización del sistema",
      subtitulo: "Módulo de administración",
      mensaje:
        "El sistema recibirá mejoras de rendimiento y seguridad el 10 de agosto a las 3:00 AM. Durante la actualización, algunos servicios estarán temporalmente fuera de línea.",
      fecha: "2025-08-07 14:35",
      leida: false,
    },
    {
      id: 2,
      tipo: "warning",
      titulo: "Permisos próximos a expirar",
      subtitulo: "Gestión de Contratos",
      mensaje:
        "Tu permiso para el módulo 'Gestión de Contratos' expirará en 5 días. Por favor, renueva tu acceso para evitar interrupciones.",
      fecha: "2025-08-07 09:20",
      leida: false,
    },
    {
      id: 3,
      tipo: "success",
      titulo: "Proceso completado",
      subtitulo: "Reportes de pagos",
      mensaje:
        "El reporte mensual de pagos se ha generado y guardado correctamente en la carpeta 'Documentos'.",
      fecha: "2025-08-06 18:45",
      leida: true,
    },
  ]);

  const marcarLeida = (id) => {
    setNotificaciones((prev) =>
      prev.map((n) => (n.id === id ? { ...n, leida: true } : n))
    );
  };

  const eliminarNotificacion = (id) => {
    setNotificaciones((prev) => prev.filter((n) => n.id !== id));
  };

  const iconoPorTipo = (tipo) => {
    switch (tipo) {
      case "info":
        return <i className="fas fa-info-circle text-primary fs-4"></i>;
      case "warning":
        return <i className="fas fa-exclamation-circle text-warning fs-4"></i>;
      case "success":
        return <i className="fas fa-check-circle text-success fs-4"></i>;
      default:
        return <i className="fas fa-bell text-secondary fs-4"></i>;
    }
  };

  const bordePorTipo = (tipo) => {
    switch (tipo) {
      case "info":
        return "border-start border-primary border-4";
      case "warning":
        return "border-start border-warning border-4";
      case "success":
        return "border-start border-success border-4";
      default:
        return "border-start border-secondary border-4";
    }
  };

  return (
    <div className="container py-4">
      <h2 className="mb-4 text-center fw-bold">
        <i className="fas fa-bell me-2 text-warning"></i> Centro de Notificaciones
      </h2>

      <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
        <div className="card-header bg-dark text-white fw-bold fs-5">
          <i className="fas fa-inbox me-2"></i> Notificaciones Recientes
        </div>
        <ul className="list-group list-group-flush">
          {notificaciones.length === 0 && (
            <li className="list-group-item text-center text-muted py-4">
              <i className="fas fa-check-circle me-2"></i>
              No hay notificaciones.
            </li>
          )}

          {notificaciones.map((n) => (
            <li
              key={n.id}
              className={`list-group-item d-flex justify-content-between align-items-start ${bordePorTipo(
                n.tipo
              )} ${n.leida ? "bg-light" : "bg-white"}`}
              style={{
                padding: "1rem",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f8f9fa")}
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = n.leida ? "#f8f9fa" : "#fff")
              }
            >
              <div className="d-flex align-items-start gap-3">
                {iconoPorTipo(n.tipo)}
                <div>
                  <div className="fw-bold">{n.titulo}</div>
                  <small className="text-muted d-block">{n.subtitulo}</small>
                  <small className="text-muted d-block mb-1">{n.fecha}</small>
                  <p className="mb-0 text-secondary">{n.mensaje}</p>
                </div>
              </div>

              <div className="d-flex align-items-center gap-2">
                {!n.leida && (
                  <button
                    className="btn btn-sm btn-outline-success"
                    title="Marcar como leída"
                    onClick={() => marcarLeida(n.id)}
                  >
                    <i className="fas fa-check"></i>
                  </button>
                )}
                <button
                  className="btn btn-sm btn-outline-danger"
                  title="Eliminar"
                  onClick={() => eliminarNotificacion(n.id)}
                >
                  <i className="fas fa-trash"></i>
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Notificaciones;
